module.exports = __webpack_public_path__ + "img/image64.4e9a2001.jpg";